import apiCall from '../utils/api';

export const activateWarrantyWithSerialNumber = async (locale, data) => {
  const url = `/ims/v2/warranty/activate?locale=${locale}`;
  const apiArgs = {
    API_CALL: {
      method: 'POST',
      data
    },
    url,
    extraPayload: {
      errorResponseRequired: true
    }
  };
  const response = await apiCall(apiArgs);
  return response;
};

export const validateSerialNumber = async(serialnumber) => {
  const url = `/ims/v1/warranty/serialnumber/${serialnumber}`;
  const apiArgs = {
    API_CALL: {
      method: 'GET'
    },
    url,
    isCountryCodeRequired: false,
    extraPayload: {
      errorResponseRequired: true
    }
  };
  const response = await apiCall(apiArgs);
  return response;
};

export const getProductDetailsAndVariants = async(locale) => {
  const url = `/ims/v1/warranty/products?locale=${locale}`;
  const apiArgs = {
    API_CALL: {
      method: 'GET'
    },
    url
  };
  const productDetails = await apiCall(apiArgs);
  return productDetails;
};

export const getProductWarrantyDetails = async(locale, warrantyId) => {
  const url = `/ims/v2/warranty/${warrantyId}?locale=${locale}`;
  const apiArgs = {
    API_CALL: {
      method: 'GET'
    },
    url,
    isCountryCodeRequired: false
  };
  const productWarrantyDetails = await apiCall(apiArgs);
  return productWarrantyDetails;
};

export const submitWarrantyForm = async(data, formType) => {
  const url = `/ims/v1/warranty/submit/${formType}`;
  const apiArgs = {
    API_CALL: {
      method: 'POST',
      data
    },
    url,
    'Content-Type': 'multipart/form-data',
    extraPayload: {
      errorResponseRequired: true
    }
  };
  const response = await apiCall(apiArgs);
  return response;
};
